import mobileMenu from './mobile-menu';
import mobileMenuToggle from './mobile-menu-toggle';
import siteWrapper from './site-wrapper';
import scrollable from './scrollable';
import body from './body';
import authNotification from './notifications/auth-notification';

export default {
  'mobile-menu': mobileMenu,
  'mobile-menu-toggle': mobileMenuToggle,
  'site-wrapper': siteWrapper,
  'scrollable': scrollable,
  'body': body,
  'auth-notification': authNotification
}
